module.exports = __webpack_public_path__ + "img/px_pc1.c0f51d6c.png";